import { CustomLocale, switchMarket } from '#/src/i18n'
import { useModal } from '#/src/custom/controllers'
import { useTranslations } from 'next-intl'
import { useUser } from 'auth'
import { useCallback } from 'react'
import { LogoutConfirmationModalProps } from '#/src/custom/controllers/modals/ConfirmationMessage'

export const useLocaleSwitch = () => {
  const { openModal } = useModal()
  const t = useTranslations('logout.Modals')
  const { user } = useUser()

  const handleChannelChange = useCallback(
    (locale: CustomLocale['locale']) => {
      if (!user?.customer) {
        switchMarket(locale)
        return
      }

      openModal<LogoutConfirmationModalProps>({
        title: t('title'),
        componentId: 'confirmation-message',
        extraArgs: {
          locale
        }
      })
    },
    [openModal, t, user]
  )

  return { handleChannelChange }
}
